import { AutoUpdateOptions, Placement } from '@floating-ui/dom';

export type SelectValue = string | { label?: string; value: any; [key: string]: unknown };

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export const MOBILE_BREAK_POINT = 768; // Default mobile breakpoint
export type CommonPositionOptions = 'auto' | 'bottom' | 'bottom-end' | 'bottom-start' | 'top-start' | 'top' | 'top-end' | 'left' | 'right';
export type CommonSizes = 'lg' | 'md' | 'sm';
export type CommonMessageTypes = 'error' | 'warning' | undefined;
export type CommonPositionOptionsV2 = 'auto' | 'bottom-start' | 'top-start' | 'bottom-end' | 'top-end';
export type CommonTargetTypes = '_self' | '_blank' | '_parent' | '_top' | undefined;
export type CommonHeadingTypes = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export type CommonAriaLiveValue = 'off' | 'polite' | 'assertive';

export type AutoPositionConfig = {
  floatingElement: HTMLElement;
  sync?: string;
  position?: Placement | 'auto';
  isInline?: boolean;
  gap?: Gap;
  referenceElement?: HTMLElement;
  overflowElement?: HTMLElement | null;
  allowedPlacements?: Placement[];
  arrowElement?: HTMLElement;
  isFlipAllowed?: boolean;
  shiftCrossAxis?: boolean;
};
export const AllowedPlacements = ['bottom-start', 'top-end', 'bottom-end', 'top-start'] as Placement[];
export type Gap = {
  mainAxis?: number;
  crossAxis?: number;
};

export type Position = Placement | 'auto';

export interface AutoPositionInterface {
  getFloatingElement(): HTMLElement;
  getSync?(): string;
  getPosition(): Position;
  getIsInline(): boolean;
  getGap?(): Gap;
  getReferenceElement(): HTMLElement;
  getOverflowElement?(): HTMLElement | null;
  getAllowedPlacements?(): Placement[];
  getArrowElement?(): HTMLElement;
  getIsFlipAllowed?(): boolean;
  getShiftCrossAxis?(): boolean;
  getAutoUpdateOptions?(): AutoUpdateOptions;
}
